import NiceModal from "@ebay/nice-modal-react";
import ExportEntitiesToPdfModal from "../../../components/dataOperationModals/exportEntitiesToPdfModal/ExportEntitiesToPdfModal";
import { DataOperation, VizContext } from "./DataOperation";
import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";

export interface ExportEntitiesToPdfOptions {
    provideSecondaryListingOption?: boolean;
    secondaryListingLabel?: string;
    titleColumnName?: string;
    subtitleColumnName?: string;
    ignoreEntityProperties?: string[];
}

export class ExportEntitiesToPdf extends DataOperation {
    filenamePrefix?: string;
    provideSecondaryListingOption: boolean;
    secondaryListingLabel?: string;
    titleColumnName?: string;
    subtitleColumnName?: string;
    ignoreEntityProperties?: string[];

    constructor(filenamePrefix?: string, options: ExportEntitiesToPdfOptions = {}) {
        super();
        this.operationId = "exportEntitiesToPdf";
        this.displayName = "Export to PDF";
        this.icon = {
            type: "fontawesome",
            icon: faFilePdf,
        };
        this.priority = "primary";
        this.context = "entity";
        this.category = "export";
        this.filenamePrefix = filenamePrefix;
        this.provideSecondaryListingOption = options.provideSecondaryListingOption ?? false;
        this.secondaryListingLabel = options.secondaryListingLabel;
        this.titleColumnName = options.titleColumnName ?? "Title";
        this.subtitleColumnName = options.subtitleColumnName ?? "Subtitle";
        this.ignoreEntityProperties = options.ignoreEntityProperties ?? [];

        NiceModal.register(this.operationId, ExportEntitiesToPdfModal);
    }

    canExecute(context: VizContext) {
        return (context.view?.filteredEntities ?? []).length > 0 || context.view?.selectedEntity !== undefined;
    }

    execute(context: VizContext) {
        NiceModal.show(this.operationId, {
            context,
            filenamePrefix: this.filenamePrefix,
            provideSecondaryListingOption: this.provideSecondaryListingOption,
            secondaryListingLabel: this.secondaryListingLabel,
            titleColumnName: this.titleColumnName,
            subtitleColumnName: this.subtitleColumnName,
            ignoreEntityProperties: this.ignoreEntityProperties,
        });
    }
}
